import { useSubscription } from '@apollo/client/react'
import { ProviderAppointmentExamDelaysSubscriptionDocument } from '@docpace/manager-graphql/dist/urql.types'
import { ProviderAppointmentExamDelaysSubscriptionResultFragment } from '@docpace/manager-graphql'

export function useProviderAppointmentExamDelaysSubscription(opts: useSubscription.Options<ProviderAppointmentExamDelaysSubscriptionResultFragment>){
    return useSubscription<ProviderAppointmentExamDelaysSubscriptionResultFragment>(ProviderAppointmentExamDelaysSubscriptionDocument, opts)
}